export enum ErrorMessages {
	RxJSMapOperators = 'You provided an invalid object where a stream was expected. You can provide an Observable, Promise, Array, or Iterable.',
	SseTimeout = 'No activity within 45000 milliseconds. Reconnecting.',
}
